//libs
import { styled } from '@nykaa/ui-components';
import { keyframes } from '@emotion/core';

const FadeIn = keyframes`
  from {
    opacity: 0;
    display: none; 
  to {
    opacity: 1;
    display: inline;
  }
`;

export const Container = styled.div`
  height: 32px;
  width: 32px;
  opacity: 0.92;
  padding: ${({ theme }) => theme.spacing.spacing20} 0;
  background: ${({ theme }) => theme.colors.wishlistIconBg};
  border-radius: 18px;
  .circle{
    height: 20px;
    width: 20px;
    margin-left: ${({ theme }) => theme.spacing.spacing20};
  }
  &:hover{
    width: 133px;
    padding-left: ${({ theme }) => theme.spacing.spacing20};
    transition: 250ms width ease-in;
    .vs-text{
      display: inline;
      visibility: visible;
      opacity: 1;
      position: absolute;
      right: 14px;
      top: 6px;
      white-space: nowrap;
      animation: ${FadeIn} 0.5s ease-in forwards;
    }
`;

export const Text = styled.span`
  display: none;
  ${({ theme }) => theme.typography.type142};
`;
